module.exports = __webpack_public_path__ + "img/2024-03-19a_2.ec7ebbf2.jpg";